import { createAsyncThunk } from '@reduxjs/toolkit'
import ContentHouse from './content-house-model'
import {
  delete_contentHouse,
  load_contentHouses,
  store_contentHouse,
} from './contentHouse-service'

export const LoadContentHousesAsync = createAsyncThunk<any, any>(
  'composer/load/contentHouse',
  async (params: { uid: string }) => {
    return await load_contentHouses(params)
  },
)

export const CreateContentHouseAsync = createAsyncThunk<any, any>(
  'composer/create/contentHouse',
  async (params: ContentHouse) => {
    return await store_contentHouse(params)
  },
)

export const DeleteContentHouseAsync = createAsyncThunk<any, any>(
  'composer/delete/contentHouse',
  async (params) => {
    return await delete_contentHouse(params)
  },
)
